import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, CalendarDays } from "lucide-react";
import Logo from "./Logo";
import { NAV_LINKS } from "../lib/brand";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-black/90 backdrop-blur-md border-b border-[#1c1c1c]" : "bg-black/60 backdrop-blur-sm"
      }`}
      data-testid="navbar"
    >
      <div className="container-kame flex items-center justify-between h-[76px]">
        <Link to="/" data-testid="nav-logo-link">
          <Logo compact />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `text-sm uppercase tracking-wider font-medium transition-colors duration-200 relative py-1 ${
                  isActive ? "text-[#B58A50]" : "text-white/85 hover:text-[#B58A50]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link to="/rezervace" className="btn-gold hidden sm:inline-flex text-sm py-2.5" data-testid="nav-reservation-btn">
            <CalendarDays size={17} /> Rezervace
          </Link>
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-mobile-toggle"
            aria-label="Menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-black border-t border-[#1c1c1c] animate-fade-up" data-testid="mobile-menu">
          <div className="container-kame py-4 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-3 text-base uppercase tracking-wider border-b border-[#151515] ${
                    isActive ? "text-[#B58A50]" : "text-white/85"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <button
              onClick={() => {
                setOpen(false);
                navigate("/rezervace");
              }}
              className="btn-gold mt-3 w-full"
              data-testid="mobile-reservation-btn"
            >
              <CalendarDays size={18} /> Rezervace
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
